<template>
  <div class="wrapper wrapper-content animated fadeInRight sideMenu">
    <div class="ibox-content m-b-sm border-bottom">
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Submission ID </label>
          <div class="col-sm-4">
            <div>
              <el-input
                v-model="stemupDetailInfo.submissionId"
                name="submissionId"
                disabled
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Entry Number </label>
          <div class="col-sm-4">
            <div>
              <el-input
                v-model="stemupDetailInfo.uploadCode"
                name="uploadCode"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="col-sm-4">
            <div>
              <el-button type="primary" @click="emailHistory()"
                >Email History</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Name of the Entry </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="stemupDetailInfo.title" disabled></el-input>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Category </label>
          <div class="col-sm-4">
            <div>
              <el-input
                v-model="category[stemupDetailInfo.level]"
                disabled
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"
            >JPC membership no. (for J Coins allocation)</label
          >
          <div class="col-sm-4">
            <div>
              <el-input v-model="stemupDetailInfo.jcoinMsg" disabled></el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-12 control-label">
            Group Request Entries File:
          </label>
        </div>
      </div>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <div class="col-sm-4">
            <div>
              <el-input
                placeholder="Brief Description of the Proposal(doc)"
                name="search"
                disabled
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
        v-if="stemupDetailInfo.level != '1'"
      >
        <div class="form-group margin-0">
          <div class="col-sm-4">
            <div>
              <el-input
                placeholder="Subject of Study (video)"
                name="search"
                disabled
              ></el-input>
            </div>
          </div>
        </div>
      </div> -->
      <template>
        <el-table
          :data="tableData"
          style="width: 100%; margin: 50px 0"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <!-- <el-table-column type="selection" width="55" fixed> </el-table-column> -->
          <el-table-column type="index" label="S/N" width="60" fixed>
          </el-table-column>
          <el-table-column label="Submission" prop="fileType">
          </el-table-column>
          <el-table-column
            label="File Name"
            v-if="$route.query.submissionType != 2"
          >
            <template slot-scope="scope">
              <p
                @click="viewInfo(scope.$index, scope.row, 1)"
                style="cursor: pointer"
              >
                {{ scope.row.fileUrl }}
              </p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="" align="center">
            <template slot-scope="scope">
              <el-button @click="viewInfo(scope.$index, scope.row)" size="mini"
                >View</el-button
              >
            </template>
          </el-table-column> -->
          <el-table-column prop="status" label="Status"> </el-table-column>
          <el-table-column label="Action" width="200">
            <template slot-scope="scope">
              <el-button
                @click="statusFlag(scope.$index, scope.row, 1)"
                v-show="scope.row.status == 'SUBMITTED'"
                size="mini"
                >Approve</el-button
              >
              <el-button
                @click="statusFlag(scope.$index, scope.row, 2)"
                v-show="scope.row.status == 'SUBMITTED'"
                size="mini"
                >Reject
              </el-button>
              <el-button
                @click="statusFlag(scope.$index, scope.row, 0)"
                v-show="scope.row.status != 'SUBMITTED'"
                size="mini"
                type="primary"
                >Edit</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="createAt"
            :label="
              $route.query.submissionType == 1
                ? 'Last Submission Date'
                : 'Submission Date'
            "
          >
          </el-table-column>
          <el-table-column
            prop="createAtTime"
            :label="
              $route.query.submissionType == 1
                ? 'Last Submission Time'
                : 'Submission Time'
            "
          >
          </el-table-column>
          <el-table-column
            label="Action Log"
            fixed="right"
            v-if="$route.query.submissionType != 2"
          >
            <template slot-scope="scope">
              <el-button @click="openFiles(scope.$index, scope.row)" size="mini"
                >Open</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin-top: 20px !important"
      >
        <div class="form-group margin-0" >
          <template v-if="$route.query.submissionType != 3">
            <label class="col-sm-2 control-label"> Rating: </label>
            <div class="col-sm-4">
              <div>
                <!-- <el-input
                  v-model="rating"
                ></el-input> -->
                <el-select v-model="rating" clearable placeholder="A/B/C/D">
                  <el-option
                    v-for="item in Rating"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </template>
          <template v-else>
            <label class="col-sm-2 control-label"> Submission Status : </label>
            <div class="col-sm-4">
              <div>
                <el-input
                  v-model="status[stemupDetailInfo.status]"
                  disabled
                ></el-input>
              </div>
            </div>
          </template>

          <div class="col-sm-2">
            <div>
              <el-button type="primary" @click="ratingHistory()"
                >History</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="$route.query.submissionType != 3"
        class="row table-responsive"
        style="padding-bottom: 20px; margin-top: 20px !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">
            Creative Products Status:
          </label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="ProductStatus" placeholder=" " clearable>
                <el-option
                  v-for="item in productStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <template v-if="$route.query.submissionType != 3">
        <div
          class="row table-responsive"
          style="padding-bottom: 20px; margin-top: 20px !important"
        >
          <div class="form-group margin-0">
              <label class="col-sm-2 control-label"> Submission Status : </label>
              <div class="col-sm-4">
                <div>
                  <el-input
                    v-model="status[stemupDetailInfo.status]"
                    disabled
                  ></el-input>
                </div>
              </div>
          </div>
        </div>
      </template>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Reason: </label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="reason" clearable placeholder=" ">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row table-responsive">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Remarks:</label>
        </div>
      </div>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="form-group margin-0">
          <el-input
            type="textarea"
            placeholder=""
            v-model="textarea"
            maxlength="300"
            show-word-limit
            clearable
          >
          </el-input>
        </div>
      </div>
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important; text-align: right"
      >
        <div class="form-group margin-0">
          <el-button @click="stemupUpdate()" type="primary">Save</el-button>
          <el-button @click="$router.go(-1)">Leave</el-button>
        </div>
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose"
      >
        <template>
          <el-table
            :data="fileTable"
            style="width: 100%; margin: 50px 0"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column type="index" label="S/N" fixed width="60">
            </el-table-column>
            <el-table-column label="File Name">
              <template slot-scope="scope">
                <p
                  @click="viewInfo(scope.$index, scope.row, 1)"
                  style="cursor: pointer"
                >
                  {{ scope.row.fileUrl }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="userName" label="Action by" fixed="right">
              <template slot-scope="scope">
                <div class="cell">
                  {{
                    scope.row.status === "SUBMITTED" ? "Applicant" : userName
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createAt" label="Action Date" fixed="right">
            </el-table-column>
            <el-table-column
              prop="createAtTime"
              label="Action Time"
              fixed="right"
            >
            </el-table-column>
            <el-table-column prop="status" label="Status"> </el-table-column>
          </el-table>
        </template>
      </el-dialog>

      <el-dialog
        :visible.sync="dialogVisible1"
        width="50%"
        :before-close="handleClose"
      >
        <template>
          <el-table
            :data="emailHistoryInfo"
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column type="index" label="S/N" fixed width="60">
            </el-table-column>

            <el-table-column prop="email" label="Email Address">
            </el-table-column>
            <el-table-column
              prop="category"
              label="Email Category"
              fixed="right"
            >
            </el-table-column>
            <el-table-column
              prop="isParent"
              label="Parent Account"
              fixed="right"
            >
            </el-table-column>
            <el-table-column
              prop="sendDate"
              label="Email Send Out Time"
              fixed="right"
            >
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            style="float: right"
          >
          </el-pagination>
          <span slot="footer" class="dialog-footer"> </span> -->
        </template>
      </el-dialog>

      <el-dialog
        :visible.sync="dialogVisible2"
        width="50%"
        :before-close="handleClose"
      >
        <template>
          <el-table
            :data="ratingHistoryInfo"
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column type="index" label="S/N" fixed width="60">
            </el-table-column>
            <el-table-column label="Report Name">
              <template slot-scope="scope">
                <p
                  @click="viewInfo(scope.$index, scope.row, 2)"
                  style="cursor: pointer"
                >
                  {{ scope.row.reportFileUrl }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="Video Name">
              <template slot-scope="scope">
                <p
                  @click="viewInfo(scope.$index, scope.row, 3)"
                  style="cursor: pointer"
                >
                  {{ scope.row.videoFileUrl }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="rating" label="Rating" v-if="$route.query.submissionType != 3"> </el-table-column>
            <el-table-column
              v-if="$route.query.submissionType != 3"
              prop="productStatus"
              label="Creative Products Status"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.productStatus
                      ? productStatus[scope.row.productStatus == "1" ? 1 : 0]
                          .label
                      : ""
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="reason" label="Reason">
              <template slot-scope="scope">
                <div>{{ Reason[scope.row.reason] }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="createdBy" label="Action By">
            </el-table-column>
            <el-table-column prop="createdAt" label="Action Date">
              <template slot-scope="scope">
                <div>
                  {{ $dayjs(scope.row.createdAt).format("YYYY-MM-DD") }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="Action Time">
              <template slot-scope="scope">
                <div>{{ $dayjs(scope.row.createdAt).format("HH:mm:ss") }}</div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            style="float: right"
          >
          </el-pagination>
          <span slot="footer" class="dialog-footer"> </span> -->
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  inject: ["reload"],
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: null,
      rating: "",
      Rating: ["A", "B", "C", "D"],
      textarea: "",
      stemupDetailInfo: {},
      tableData: [],
      fileTable: [],
      emailHistoryInfo: [],
      category: {
        1: "Junior Primary School",
        2: "Senior Primary School",
        3: "Junior Secondary School",
        4: "Senior Secondary School",
        5: "Primary School",
        6: "Secondary School",
        7: "Open",
      },
      status: {
        "-1": "APPLIED",
        0: "SUBMITTED",
        1: "APPROVED",
        2: "REJECTED",
      },
      ProductStatus: "",
      productStatus: [
        {
          value: 2,
          label: "Invited",
        },
        {
          value: 1,
          label: "Submitted",
        },
      ],
      FileType: {
        1: "Creative Proposal/Project Report",
        2: "Video",
      },
      options: [
        {
          value: 1,
          label: "Content Not Match",
        },
        {
          value: 2,
          label: "Miss File",
        },
        {
          value: 3,
          label: "Incomplete File",
        },
        {
          value: 4,
          label: "Plagiarism",
        },
        {
          value: 5,
          label: "Others,Please specify",
        },
      ],
      reason: null,
      Reason: {
        1: "Content Not Match",
        2: "Miss File",
        3: "Incomplete File",
        4: "Plagiarism",
        5: "Others,Please specify",
      },
      stemupDetailInfoa: [],
      ratingHistoryInfo: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
    };
  },

  created() {
    this.stemupDetail();
  },
  components: {
    draggable,
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.emailHistory();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.emailHistory();
    },
    statusFlag(index, row, statusI) {
      this.stemupDetailInfoa = [];

      switch (statusI) {
        case 0:
          this.tableData[index].status = "SUBMITTED";
          break;
        case 1:
          this.tableData[index].status = "APPROVED";
          break;
        case 2:
          this.tableData[index].status = "REJECTED";
          break;
      }
      this.tableData.forEach((res) => {
        this.stemupDetailInfoa.push(res.status);
      });
      if (
        this.stemupDetailInfo.level == 2 ||
        this.stemupDetailInfo.level == 4 ||
        this.stemupDetailInfo.level == 3
      ) {
        if (this.tableData.length == 2) {
          if (this.stemupDetailInfoa.some((res) => res == "SUBMITTED")) {
            this.stemupDetailInfo.status = 0;
          } else if (this.stemupDetailInfoa.every((res) => res == "APPROVED")) {
            this.stemupDetailInfo.status = 1;
          } else {
            this.stemupDetailInfo.status = 2;
          }
        } else {
          this.stemupDetailInfo.status = 0;
        }
      } else {
        if (this.stemupDetailInfoa.some((res) => res == "SUBMITTED")) {
          this.stemupDetailInfo.status = 0;
        } else if (this.stemupDetailInfoa.every((res) => res == "APPROVED")) {
          this.stemupDetailInfo.status = 1;
        } else {
          this.stemupDetailInfo.status = 2;
        }
      }
    },
    viewInfo(index, row, id) {
      let typeO = [];
      if (id == 1) {
        typeO = row.fileUrl.split(".");
        const typeList = ["mov", "mp4", "pdf", "mpeg", "wmv", "avi",];
        if (typeO.length && typeList.includes(typeO[typeO.length-1].toLowerCase())) {
          window.open(row.fullFileUrl);
        } else {
          window.open(
            "http://view.officeapps.live.com/op/view.aspx?src=" +
              encodeURIComponent(row.fullFileUrl)
          );
        }
      } else if (id == 2) {
        window.open(
          "http://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(row.fullReportFileUrl)
        );
      } else {
        window.open(row.fullVideoFileUrl);
      }
    },
    handleClose(done) {
      done();
    },
    statusConversion(array) {
      array.forEach((element) => {
        element.status = this.status[element.status];
      });
    },
    async stemupDetail() {
      var objdata = this.getAuthObj();
      objdata.id = this.$route.query.id;
      objdata.apiUrl = this.apiConfig.stemupDetail;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.stemupDetailInfo = data.data.result;
      //TODO
      if (this.stemupDetailInfo.jcoinMsg === "No Member ID Info")
        this.stemupDetailInfo.jcoinMsg = "No membership no. provided";
      this.tableData = this.stemupDetailInfo.lstFile;
      this.rating = this.stemupDetailInfo.rating;
      // if (this.stemupDetailInfo.productStatus === null) {
      //   this.stemupDetailInfo.productStatus = 0;
      // }

      this.ProductStatus = this.stemupDetailInfo.productStatus;
      this.reason = this.Reason[this.stemupDetailInfo.reason];
      this.textarea = this.stemupDetailInfo.remark;
      this.tableData.forEach((res) => {
        res.fileType = this.FileType[res.fileType];
      });
      this.statusConversion(this.tableData);
    },

    async openFiles(index, row) {
      let fileType = row.fileType;
      if (fileType == "Video") {
        fileType = 2;
      } else {
        fileType = 1;
      }
      var objdata = this.getAuthObj();
      objdata.fileType = fileType;
      objdata.id = this.$route.query.id;
      objdata.apiUrl = this.apiConfig.stemupFiles;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.fileTable = data.data.result;
      this.statusConversion(this.fileTable);
      this.dialogVisible = true;
    },
    async emailHistory() {
      var objdata = this.getAuthObj();
      objdata.id = this.$route.query.id;
      objdata.apiUrl = this.apiConfig.stemupEmails;
      objdata.pageIndex = this.pageIndex;
      objdata.pageSize = this.pageSize;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.emailHistoryInfo = data.data.result;
      this.dialogVisible1 = true;
    },
    async ratingHistory() {
      var objdata = this.getAuthObj();
      objdata.id = this.$route.query.id;
      objdata.apiUrl = this.apiConfig.stemupRatings;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.ratingHistoryInfo = data.data.result.reverse();
      this.dialogVisible2 = true;
    },

    async stemupUpdate() {
      let cluster_info = this.status;
      for (let k in cluster_info) {
        let value = cluster_info[k];
        cluster_info[value] = k;
        delete cluster_info[k];
      }
      let lstStemupAuditDTO = [];
      this.tableData.forEach((res) => {
        lstStemupAuditDTO.push({
          id: res.id,
          status: cluster_info[res.status],
        });
      });
      var objdata = this.getAuthObj();
      if (typeof this.ProductStatus === "string" && this.ProductStatus != "") {
        this.ProductStatus = this.stemupDetailInfo.productStatus;
      }
      if (typeof this.reason === "string" && this.reason != "") {
        this.reason = this.stemupDetailInfo.reason;
      }
      objdata.id = this.$route.query.id;
      objdata.reason = this.reason;
      objdata.remark = this.textarea;
      objdata.lstStemupAuditDTO = lstStemupAuditDTO;
      objdata.apiUrl = this.apiConfig.stemupUpdate;
      objdata.rating = this.rating;
      if (this.$route.query.submissionType != 3) {
        objdata.productStatus = this.ProductStatus;
      }
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.reload();
      this.$message({
        message: "Save Success",
        type: "success",
      });
    },
  },
  mounted() {},
};
</script>
<style>
.sideMenu .el-dialog {
  height: 450px !important;
  overflow: scroll !important;
}
</style>